<template>
  <div class="top-section container">
    <div class="top-section__bg-main-image--left" />
    <div class="top-section__bg-main-image--right" />
    <div class="top-section__bg-image-wrap">
      <img
        src="/static/images/Box.png"
        class="top-section__bg-image--image1"
      >
      <img
        src="/static/images/Headphones2.png"
        class="top-section__bg-image--image2"
      >
      <img
        src="/static/images/Doll.png"
        class="top-section__bg-image--image3"
      >
      <img
        src="/static/images/Bear.png"
        class="top-section__bg-image--image4"
      >
      <img
        src="/static/images/Drone.png"
        class="top-section__bg-image--image5"
      >
    </div>
    <div class="top-section__content">
      <h1 class="top-section__title">Product sourcing <br>and shipping.<br>Solved.</h1>
      <span class="top-section__subtitle">A-Z solutions for producing and sourcing products, to delivery to your customers.</span>
      <ui-button
        class="top-section__button"
        theme="green"
        @click="handleButtonClick"
      >
        Learn More
      </ui-button>
    </div>
  </div>
</template>

<script>
import scrollTo from 'scroll-to'
import UiButton from './components/ui/UiButton'

export default {
  name: 'TopSection',
  components: {
    UiButton,
  },
  methods: {
    handleButtonClick () {
      const whySection = document.getElementById('why-section')
      scrollTo(document.documentElement.scrolltop, whySection.offsetTop - 120, {
        duration: 700
      })
    },
  },
}
</script>

<style lang="sass">
@import '~styles/shared'

.top-section
  position: relative
  padding-bottom: 56px

  @include tablet
    padding-bottom: 126px

  @include largedesktop
    padding-bottom: 184px

.top-section__bg-images
  position: relative
  flex-shrink: 0

.top-section__bg-main-image--left
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-image: url(/static/images/top-bg-left.png)
  background-size: 800px 566px
  background-repeat: no-repeat
  background-position: -260px -72px

  @include largedesktop
    background-size: 1148px 800px
    background-position: -178px -92px

.top-section__bg-main-image--right
  display: none

  @include desktop
    display: block
    position: absolute
    top: 0
    right: -528px
    width: 100%
    height: 100%
    background-image: url(/static/images/top-bg-right.png)
    background-size: 980px 436px
    background-repeat: no-repeat
    background-position: right bottom

.top-section__bg-image-wrap
  position: relative
  width: 295px
  margin: 0 auto
  left: -7px

  @include tablet
    left: 0
    width: 820px

  @include largedesktop
    width: auto
    position: static

[class*=top-section__bg-image--]
  position: absolute
  width: 200px
  z-index: 10

.top-section__bg-image--image1
  width: 300px
  height: 300px
  top: -183px
  left: 6px
  animation: rotating-reverse 50s linear infinite

  @include tablet
    left: 1%
    width: 525px
    height: 525px
    top: -274px

  @include largedesktop
    left: 15.8%
    width: 750px
    height: 750px
    top: -384px

.top-section__bg-image--image2
  width: 315px
  height: 315px
  top: -138px
  left: -134px
  animation: rotating 30s linear infinite

  @include tablet
    width: 525px
    height: 525px
    top: -128px
    left: -26.8%

  @include largedesktop
    width: 670px
    height: 670px
    top: -136px
    left: -6.2%

.top-section__bg-image--image3
  width: 315px
  height: 315px
  top: -104px
  left: 63px
  animation: rotating-reverse 70s linear infinite

  @include tablet
    width: 530px
    height: 530px
    top: -45px
    left: -2.7%

  @include largedesktop
    width: 750px
    height: 750px
    top: -55px
    left: 13%

.top-section__bg-image--image4
  width: 310px
  height: 310px
  top: -83px
  left: -24px
  animation: rotating-reverse 90s linear infinite

  @include tablet
    width: 530px
    height: 530px
    top: 89.9px
    left: -18.2%

  @include largedesktop
     width: 750px
     height: 750px
     top: 137px
     left: .3%

.top-section__bg-image--image5
  width: 310px
  height: 310px
  top: -109px
  left: 169px
  animation: rotating 100s linear infinite

  @include tablet
    width: 530px
    height: 530px
    top: 118px
    left: -40.8%

  @include largedesktop
    width: 750px
    height: 750px
    top: 177px
    left: -18%

.top-section__content
  padding-top: 131px
  position: relative
  z-index: 10

  @include tablet
    width: 48.9%
    margin-left: auto
    margin-right: 0
    padding-top: 74px

  @include largedesktop
    padding-top: 125px
    width: 49.3%

.top-section__title
  font: 600 34px/35px $font-family-secondary
  color: #1d3762
  padding-bottom: 14px

  @include tablet
    font-size: 44px
    line-height: 45px
    padding-bottom: 20px

  @include largedesktop
    font-size: 69px
    padding-right: 20px
    padding-bottom: 20px
    line-height: 70px

.top-section__subtitle
  display: block
  font: 700 16px/23px $font-family-secondary
  color: #1d3762
  padding-left: 3px
  letter-spacing: 0

  @include tablet
    font-size: 18px
    line-height: 25px
    display: inline-block

  @include largedesktop
    font-size: 22px
    padding-right: 200px
    letter-spacing: 0
    line-height: 31px

@keyframes rotating
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)

@keyframes rotating-reverse
  from
    transform: rotate(360deg)
  to
    transform: rotate(0deg)
</style>



// WEBPACK FOOTER //
// src/TopSection.vue